module.exports = __webpack_public_path__ + "media/img/4_year-2-cd6127de.png";